import React, { useState, useEffect } from 'react';
import { LoaderCircle, ChevronDown, ChevronUp } from 'lucide-react';

const ThinkingProcess = ({ 
    content, 
    isStreaming 
  }: { 
    content: string;
    isStreaming: boolean;
  }) => {
    const [isExpanded, setIsExpanded] = useState(isStreaming);
  
    useEffect(() => {
      if (isStreaming) {
        setIsExpanded(true);
      }
    }, [isStreaming]);
  
    if (!content) return null;
  
    return (
      <div className="mt-3">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center gap-2 text-gray-500 hover:text-gray-700 text-sm font-medium p-2 rounded-md hover:bg-gray-100 transition-colors"
        >
          {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          Thought Process
          {isStreaming && (
            <LoaderCircle className="animate-spin ml-2" size={14} />
          )}
        </button>
        
        {isExpanded && (
          <div className="mt-2 p-4 bg-gray-50 rounded-md">
            <div className="text-gray-600 text-sm whitespace-pre-wrap font-mono">
              {content}
            </div>
          </div>
        )}
      </div>
    );
  };

export default ThinkingProcess;